import gql from "graphql-tag";

export const GET_WEB_HISTORY = gql`
    query WebHistory($webHistoryId: ID!){
        webHistory(webHistoryId: $webHistoryId) {
            webHistoryId
            userId
            parentId
            parentType
            url
            createdAt
            updatedAt
        }
    }
`;

export const GET_WEB_HISTORYS = gql`
    query WebHistorys($searchStr: String, $limit: Int, $offset: Int, $showDeleted: Boolean, $orderList: [String]){
        webHistorys(searchStr: $searchStr, limit: $limit, offset: $offset, showDeleted: $showDeleted, orderList: $orderList) {
            webHistoryId
            userId
            parentId
            parentType
            url
            createdAt
            updatedAt
        }
    }
`;

export const CREATE_WEB_HISTORY = gql`
    mutation CreateWebHistory($newWebHistory: newWebHistory!) {
        createWebHistory(
            newWebHistory: $newWebHistory
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const DELETE_WEB_HISTORY = gql`
    mutation DeleteWebHistory($deleteWebHistoryId: ID!) {
        deleteWebHistory(
            deleteWebHistoryId: $deleteWebHistoryId
        ) {
            returnCode
            message
        }
    }
`;

